import { HeaderButton } from '@/components/elements/HeaderButton/HeaderButton.types';
import { User } from '@/types/user';
import { SEARCH_HEADER_BUTTON } from './SearchHeader.constants';

export const getSearchHeaderButtons = (user: User, isMobileView: boolean): HeaderButton[] => {
  if (user) {
    const items: HeaderButton[] = [];

    if (!isMobileView) {
      items.push(SEARCH_HEADER_BUTTON.MY_BOOKINGS, SEARCH_HEADER_BUTTON.FAVORITES);
    }

    items.push(SEARCH_HEADER_BUTTON.PROFILE);
    return items;
  }

  return [SEARCH_HEADER_BUTTON.CONNECT_COMPANY, SEARCH_HEADER_BUTTON.LOGIN];
};
